/**
 * plugins/quote.ts — Citações de regra de negócio (.business-quote)
 */

import { VtbPlugin, IVtbRegistry, SmartCtx, closestInside } from '../types';

export class QuotePlugin implements VtbPlugin {
    readonly panelId = 'vtb-quote';
    readonly selectorHints = ['div.business-quote', '.business-quote', '[data-vtb-id="business-quote"]'];

    detect(target: HTMLElement, visualEditor: HTMLElement): SmartCtx | null {
        const el = closestInside(target, visualEditor, e => 
            e.classList.contains('business-quote') || e.dataset.vtbId === 'business-quote'
        );
        if (!el) return null;
        return { type: this.panelId, label: 'Citação', el };
    }

    activate(ctx: SmartCtx, registry: IVtbRegistry): void {
        const q = ctx.el;
        const p = q.querySelector('p');
        const c = q.querySelector('cite');
        
        const textInput = registry.q<HTMLTextAreaElement>('vtb-quote-text');
        const citeInput = registry.q<HTMLInputElement>('vtb-quote-cite');
        
        if (textInput) textInput.value = p?.textContent?.trim() ?? '';
        if (citeInput) citeInput.value = c?.textContent?.trim().replace(/^—\s*/, '') ?? '';
    }

    setup(registry: IVtbRegistry): void {
        registry.q('vtb-quote-apply')?.addEventListener('click', () => this._apply(registry));
    }

    private _apply(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;

        const text = registry.q<HTMLTextAreaElement>('vtb-quote-text')?.value?.trim() ?? '';
        const cite = registry.q<HTMLInputElement>('vtb-quote-cite')?.value?.trim() ?? '';

        let p = ctx.el.querySelector('p');
        if (!p) {
            p = document.createElement('p');
            ctx.el.prepend(p);
        }
        p.textContent = text;

        let c = ctx.el.querySelector('cite');
        if (cite) {
            if (!c) {
                c = document.createElement('cite');
                ctx.el.appendChild(c);
            }
            c.textContent = '— ' + cite;
        } else if (c) {
            c.remove();
        }

        registry.sync();
    }
}
